import { createFileRoute } from '@tanstack/react-router';
import { DripGoalSubTab } from '@/components/admin/DripGoalSubTab';

function Page() {
  return <DripGoalSubTab goal='conversion' />;
}

export const Route = createFileRoute('/admin/drip-campaigns/conversion')({
  component: Page,
});
